const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 2,
});

export const formatCurrency = (value) => {
  const numericValue = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numericValue)) {
    return currencyFormatter.format(0);
  }
  return currencyFormatter.format(numericValue);
};

export const parseCurrency = (value) => {
  if (!value) {
    return 0;
  }

  const normalized = value
    .toString()
    .replace(/[R$\s]/gi, '')
    .replace(/\./g, '')
    .replace(',', '.');

  const numericValue = Number(normalized);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const sanitizeCurrencyInput = (raw) => {
    const digits = raw.replace(/\D/g, '');
    if (!digits) {
        return '';
    }
    const cents = parseInt(digits, 10);
    const valueInReais = cents / 100;
    const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
    });
    return formatter.format(valueInReais);
};

export const getCurrencyFormatter = () => currencyFormatter;

const currencyUtils = {
  formatCurrency,
  parseCurrency,
  sanitizeCurrencyInput,
  getCurrencyFormatter,
};

export default currencyUtils;
